export const baseUrl = "/api/";


